import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { User, UserStatus } from '@marageti/z4-sdk/lib/auth';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import {
  useContextMenu, useApiClient, useFetch, useFetchImmutable,
} from '@marageti/z4-lib';
import { CountryCodeMap } from '@marageti/z4-sdk/lib/standards';
import { Agent } from '@marageti/z4-sdk/lib/people';
import AgentHeaderView from './agent-sub-navigation-view';
import { getMatchingUser } from '../../utils/auth';
import { TabItem } from '../sub-navigation/types';

const AGENT_LINKS: TabItem[] = [
  {
    label: 'trips',
    to: 'trip-matches',
  },
  {
    label: 'profile',
    to: '',
  },
];

const AgentSubNavigationContainer = () => {
  const navigate = useNavigate();
  const apiClient = useApiClient();
  const { agentId } = useParams();
  const [contextMenuAnchor, setContextMenuAnchor, contextMenuOpen] = useContextMenu();

  const { data: countryCodes } = useFetchImmutable<CountryCodeMap>(apiClient.standardsClient.getCountryCodes, [], true);
  const { data: agent, mutate, error: agentError } = useFetch<Agent>(apiClient.peopleClient.getAgent, [agentId], !!agentId);
  const userInfo = agent ? getMatchingUser(agent.email, agent.userInfo) : undefined;
  const { data: user, error: userError } = useFetch<User>(apiClient.authClient.getUser, [userInfo?.id], userInfo !== undefined);

  const [submissionError, setSubmissionError] = useState<ApiError>();

  if (userError || submissionError || agentError) {
    const apiError: ApiError = userError || submissionError || agentError;
    if (apiError.code === 401) navigate('/logout');
  }

  const onClickNewStatus = (status: UserStatus) => {
    if (user && agent) {
      const updatedUser: User = {
        ...user,
        status,
      };
      apiClient.authClient.putUser(user.id, updatedUser)
        .then((res) => {
          if (agent.userInfo && agent.userInfo.length > 0) {
            const updatedUserInfo = [...agent.userInfo];
            updatedUserInfo[0] = {
              ...updatedUserInfo[0],
              status: res.status,
            };
            mutate();
          }
          setContextMenuAnchor(null);
        })
        .catch(setSubmissionError);
    }
  };

  return (
    <AgentHeaderView
      contextMenuAnchor={contextMenuAnchor}
      contextMenuOpen={contextMenuOpen}
      countryCodes={countryCodes}
      onClickNewStatus={onClickNewStatus}
      setContextMenuAnchor={setContextMenuAnchor}
      agent={agent}
      tabs={AGENT_LINKS}
    />
  );
};

export default AgentSubNavigationContainer;
